<template>
  <div>
    <modal-template
      v-show="toggle"
      @close="toggleInfoModal"
      class="override-modal"
    >
      <template #header>
        <i class="icon-ic_close" @click="toggleInfoModal" />
        <h3>{{ $t('agenda.confirmar-internacao.titulo') }}</h3>
      </template>
      <template #body>
        <div>
          <p>{{ $t('agenda.confirmar-internacao.mensagem') }}</p>
        </div>
        <br />
        <h4>
          <b>{{ $t('agenda.confirmar-internacao.orientacao.titulo') }}</b>
        </h4>
        <ul>
          <li v-if="ehMaiorDeIdade()">
            {{ $t('agenda.confirmar-internacao.orientacao.maior-de-idade') }}
          </li>
          <li v-else>
            {{ $t('agenda.confirmar-internacao.orientacao.menor-de-idade-p1') }}
            <b>{{
              $t('agenda.confirmar-internacao.orientacao.menor-de-idade-p2')
            }}</b>
            {{ $t('agenda.confirmar-internacao.orientacao.menor-de-idade-p3') }}
          </li>
        </ul>
      </template>
      <template #footer>
        <div class="columns absence">
          <b-button
            class="column button button-secondary"
            :loading="loading"
            @click="confirmarInternacao()"
          >
            {{ $t('botoes.sim') }}
          </b-button>
          &nbsp;
          <b-button v-if="!loading" class="column" @click="toggleInfoModal()">
            {{ $t('botoes.voltar') }}
          </b-button>
        </div>
      </template>
    </modal-template>
  </div>
</template>

<script>
import ModalTemplate from './ModalTemplate'
import AgendamentoService from '@/services/agendamento-service'
import { mapGetters } from 'vuex'

export default {
  name: 'ConfirmarInternacaoModal',
  components: { ModalTemplate },
  props: {
    toggle: {
      type: Boolean,
      default: false
    },
    internacao: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      paciente: 'dadosPaciente'
    })
  },
  methods: {
    toggleInfoModal() {
      this.$emit('closeModal', 'cancelar')
    },
    confirmarInternacao() {
      this.loading = true
      AgendamentoService.postConfirmarInternacao(this.$props.internacao)
        .then((response) => {
          if (response.status === 200) {
            this.$emit('closeModal', 'confirmado')
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    ehMaiorDeIdade() {
      const dataNascimento = new Date(this.paciente?.DataNascimento)
      const hoje = new Date()

      const dataMaiorDeIdade = new Date(dataNascimento)
      dataMaiorDeIdade.setFullYear(dataMaiorDeIdade.getFullYear() + 18)

      return hoje >= dataMaiorDeIdade
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/base';

.absence {
  margin-bottom: 4px;
  margin: 0 auto;
  width: 90%;
  .confirm {
    margin: auto;
    box-sizing: border-box;
    height: 2.5rem;
    width: 12.5rem;

    color: var(--light-blue);
    border: 0.0625rem solid $light-blue;
    border-color: var(--light-blue);
    border-radius: 0.25rem;
    &:hover {
      color: var(--neutral-color-5);

      background-color: var(--light-blue);
      transition: all 0.2s;
    }
  }

  .cancel {
    color: var(--orange-dark);
    font-weight: 500;
    font-size: 0.875rem;
    height: 2.25rem;
    border: 1px solid $orange-dark-light;
  }

  @media screen and (max-width: 768px) {
    .cancel {
      margin-top: 1rem;
    }
  }
}

ul {
  list-style: inside;
}
</style>
